module.exports = __webpack_public_path__ + "static/img/coming.88727c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/coming.png
// module id = uMlk
// module chunks = 1